export default __webpack_public_path__ + "static/media/chevron.7ff4b12d.svg";